export default __webpack_public_path__ + "static/media/curae_favicon.28c4c6b5.ico";